module.exports = __webpack_public_path__ + "static/media/joobz.537c131d.svg";